// extracted by mini-css-extract-plugin
export default {"form":"FlyerForm_form__-WMF3"};